import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { TopbarContainer } from '..';
import { LayoutWrapperFooter, LayoutWrapperMain, LayoutWrapperTopbar } from '../../components';
import css from './EditListingPage.module.css';
import Footer from './Footer';

interface EditListingPageLayoutProps {
  submitButton?: React.ReactElement;
  saveDraftButton?: React.ReactElement;
  progressBar?: React.ReactElement;
  children?: React.ReactNode;
}

const EditListingPageLayout: FC<EditListingPageLayoutProps> = (props) => {
  const { children, submitButton, saveDraftButton, progressBar } = props;

  return (
    <>
      <LayoutWrapperTopbar>
        <TopbarContainer
          className={css.topbar}
          mobileRootClassName={css.mobileTopbar}
          desktopClassName={css.desktopTopbar}
        />
        {progressBar}
      </LayoutWrapperTopbar>
      <LayoutWrapperMain>
        <Box display="flex" flexDirection="column" alignSelf="center" className={css.main}>
          {children}
        </Box>
      </LayoutWrapperMain>
      <LayoutWrapperFooter>
        <Footer submitButton={submitButton} saveDraftButton={saveDraftButton} />
      </LayoutWrapperFooter>
    </>
  );
};

export default EditListingPageLayout;
